<template>
  <div class="info-page">
    <!-- 仅原来的 section 3 内容 -->
    <div v-wechat-title="'《提灯与地下城》海灵主宰·龙拳破天'"></div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' :gameName="gameName" :game_id="39"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      @loginSuccess="loginSuccess" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='0' :newUserInfo="newUserInfo" />
    <div class="content-box">
      <div class="banner">
        <div class="banner-title" />
      </div>
      <div class="activities-box">
        <div class="activities-items">
          <a class="activities-item" @click="goLink('https://pay.qingcigame.com/pay?gameId=33', '拳新版本_信息页_官方充值')">
            <div class="activities-content" />
          </a>
          <a class="activities-item"
            @click="goLink('https://l.taptap.cn/5LuDYWAv?channel=rep-rep_fqcowdjgrfe', '拳新版本_信息页_TapTap论坛活动')">
            <div class="activities-content" />
          </a>
          <a class="activities-item"
            @click="goLink('https://l.taptap.cn/SbYIAvpE?channel=rep-rep_sxppzlztcqx_h5url4942', '拳新版本_信息页_TapTap签到领奖')">
            <div class="activities-content" />
          </a>

        </div>
      </div>
      <div class="game-feature-box">
        <div class="game-feature-content">
          <div class="game-feature-swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="card in gameFeatureCards" :key="card.id">
                <img :src="card.image" alt="">
              </div>
            </div>
          </div>
          <div class="game-feature-swiper-button-next swiper-button-next"></div>
          <div class="game-feature-swiper-button-prev swiper-button-prev"></div>
          <div class="game-feature-swiper-pagination swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 视频弹窗 -->
    <div class="video_wrap popup_wrap" v-show="videoShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <video v-if="videoShow" autoplay="autoplay" controlslist="nodownload" disablepictureinpicture="true" controls
            :src="pvUrl"></video>
          <div class="close_btn" @click="closePopup" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Header from '../Header/index.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast, Indicator } from 'mint-ui'
import { headerConfig } from '../headerConfig'
import Os from '@/components/os'
import Login from '@/components/login'
import { getTimeStamp, buriedLogger } from "@/utils/utils"
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { onGetInitDataAPI } from '../api';

export default {
  name: 'RecallInfo',
  components: {
    Header,
    swiper,
    swiperSlide,
    Login,
    Os,
  },

  props: {
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum('拳新版本_信息页');
        }
      }
    }
  },
  data() {
    return {
      newUserInfo: {},
      headerConfig,
      gameName: 'tideng',
      downloadUrl: 'https://tideng.qingcigame.com/',
      loginTypes: ["sms", "password"],
      activitiesSwiper: null,
      gameFeatureSwiper: null,
      gameFeatureCards: [
        { id: 1, image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/03-1.png' },
        { id: 2, image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/03-2.png' },
        { id: 3, image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/03-3.png' },
        { id: 4, image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/03-4.png' },
        { id: 5, image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/03-5.png' },
        { id: 6, image: 'https://download4.qcplay.com/h5-images/active/tideng/recall/03-6.png' }
      ],
      activeIndex: 0,
      videoShow: false,
      pvUrl: '',
      currentUperIndex: 0,
      uperCards: [
        { id: 1, name: '小芃', videoUrl: 'https://download4.qcplay.com/qcgame-admin/IrqyiXnj8CcOZ4aIDhdRqMXec9rvYwbjFcHy65HD.mp4' },
        { id: 2, name: '薪儿姐', videoUrl: 'https://download4.qcplay.com/qcgame-admin/9vAH6w2qhsboyBBM1dQNB7cBG1wcmH9o5Q5LDEc6.mp4' },
        // { id: 3, name: '三金啊', videoUrl: '' },
      ],
      currentTime: '',
    }
  },
  created() {
  },
  mounted() {
    console.log(this.userInfo)
    this.initSwiperGameFeature()
    this.logger.sum('拳新版本_信息页');
    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    this.friend_id = urlParams.get('friend_id');
    const queryUA = urlParams.get('ua');
    const module = urlParams.get('module');
    const type = urlParams.get('type');

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('friend_id');
    urlParams.delete('module');
    urlParams.delete('ua');
    urlParams.delete('type');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);
    if (type === 'by3') {
      this.headerConfig.operation_btn.download.link = 'https://download4.qcplay.com/apk-v2/qc-kol-1168625.apk'
    } else {
      this.headerConfig.operation_btn.download.link = 'https://download4.qcplay.com/apk-v2/qc-kol-1168626.apk'
    }
    if (/iP(hone|od|ad)/.test(navigator.userAgent)) {
      this.headerConfig.operation_btn.download.link = 'https://apps.apple.com/cn/app/%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E-1-5%E7%89%88%E6%9C%AC%E5%85%89%E6%9A%97%E5%AF%B9%E5%86%B3/id1507356201?l=en'
    }
    this.$set(this, 'headerConfig', headerConfig)
    this.newUserInfo = JSON.parse(JSON.stringify(this.userInfo))
    if (this.activeInfo.is_bind) {
      delete this.newUserInfo.role_name
    }
    this.setShare({
      link: `https://h5.qingcigame.com/tideng/recall/anniversary${getTimeStamp()}`,
      title: '《提灯与地下城》新版本火热上线',
      imgUrl: 'https://download4.qcplay.com/qcgame-api/9VHWniV91Q3sfOtCISCEmR9aWVEaAj7jLqrT2VKZ.png',
      desc: '参与组队积分活动，可获得史诗级头衔、10星装备升星券等丰厚奖励，集结归来的灯友，就差你了！'
    })
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  methods: {
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.activity = response.data.activity;
            this.user_info = response.data.user_info;

            this.onInitDataCallback(response);

            this.newUserInfo = JSON.parse(JSON.stringify(response.data.user_info))
            if (response.data.activity.is_bind) {
              delete this.newUserInfo.role_name
            } else {
              this.changeOsPopup(true)
            }
            this.setUserInfo(response.data.user_info);
            this.setActiveInfo(response.data.activity);

            setTimeout(() => { this.showTopBox = true; }, 10);
            setTimeout(() => { this.showTitleBox = true; }, 200);
            return;
          } else {
            setTimeout(() => { this.showTopBox = true; }, 10);
          }
        })
    },
    chooseUper(name, index) {
      if (this.currentUperIndex === index) return
      this.currentUperIndex = index
    },
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    isNotStarted(time) {
      const currentTime = this.currentTime ? new Date(this.currentTime.replace(/-/g, "/")) : new Date()
      return new Date(time.replace(/-/g, "/")) > currentTime; // 如果活动时间在当前时间之后
    },
    goToSlide(targetIndex) {
      const swiper = this.activitiesSwiper;
      const currentIndex = swiper.activeIndex; // 当前 DOM 索引
      const slides = Array.from(swiper.slides); // 克隆后的所有 slide

      // 获取所有匹配的 slide 索引
      const matchingIndexes = slides
        .map((slide, i) => ({
          index: i,
          realIndex: +slide.getAttribute('data-swiper-slide-index')
        }))
        .filter(slide => slide.realIndex === targetIndex)

      // 找到与当前 slide 最接近的目标 index
      const nearest = matchingIndexes.reduce((prev, curr) => {
        return Math.abs(curr.index - currentIndex) < Math.abs(prev.index - currentIndex)
          ? curr
          : prev;
      });

      if (nearest) {
        swiper.slideTo(nearest.index, 300);
        this.activeIndex = targetIndex;
        this.scrollToCenter(targetIndex)
      }
    },
    scrollToCenter(index) {
      const container = this.$refs.tabsContainer;
      const tabItems = this.$refs.tabItems;
      const tab = tabItems[index];

      // 计算滚动的中心位置
      const tabOffsetLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const containerWidth = container.offsetWidth;

      const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    },
    goLink(url, loggerName) {
      if (url === '') return this.onToast('暂未开启，敬请期待')
      Indicator.open();
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    initSwiperGameFeature() {
      this.gameFeatureSwiper = new Swiper('.game-feature-swiper-container', {
        slidesPerView: 1,
        loop: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        nextButton: '.next',
        prevButton: '.prev',
        spaceBetween: '-10%',
        slidesPerView: 'auto',
        autoplayDisableOnInteraction: false,
        autoplay: 2000,
        nextButton: '.game-feature-swiper-button-next',
        prevButton: '.game-feature-swiper-button-prev',
        pagination: '.game-feature-swiper-pagination',
        coverflow: {
          rotate: 0, // 旋转的角度
          stretch: 10, // 拉伸   图片间左右的间距和密集度
          depth: 115, // 深度   切换图片间上下的间距和密集度
          modifier: 11, // 修正值 该值越大前面的效果越明显
          slideShadows: false
        },
      })
    },
    openPopup() {
      const { name, videoUrl } = this.uperCards.find((i, index) => index === this.currentUperIndex) || {}
      this.pvUrl = videoUrl
      this.videoShow = true
      this.logger.sum(`五周年庆_${name}视频点击`)
    },
    closePopup() {
      this.videoShow = false
    },
    selectCallback() {
    },
    loginSuccess() {
      this.getLoginContainer()
      console.log('登录成功')
    },
    osCancell() {
      console.log('osCancell')
    },
    getSelectInfo() {
      console.log('getSelectInfo')
    },
    logoutCallback() {
      console.log('logoutCallback')
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
}
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/recall/info/index.vue